import React from 'react'
import Heading from 'components/Heading'
import Flag from 'components/Flag'
import ChartTabs from 'components/ChartTabs'
import CurrencyDetails from 'components/CurrencyDetails'
import CryptoCurrencyDetails from 'components/CryptoCurrencyDetails'
import Meta from 'components/Meta'

export const SingleCurrency = ({currencyRate, mode, ...props}) => {
	const { flag, name, abbreviature} = currencyRate
	return <div className='o-layout'>
		<div className='o-layout__item u-1/1'>
			<Meta page={mode === 'monetary' ? 'currency' : 'cryptocurrency'} name={name} abbreviature={abbreviature} />
			<Heading
				text='Валутни курсове и графики'
				classes='u-heading-line u-heading-line-cornflower'
			/>
		</div>
		<div className='o-layout__item u-1/1'>
			<div className='u-margin-vertical u-center-on-mobile'>
				<p className='u-margin-none'>
					<Flag className='u-margin-right-tiny' isCrypto={ mode === 'crypto' } src={flag} alt={name}  />
					<span className='u-weight--semi-bold'>{ abbreviature }</span> - { name }
				</p>
				{
					mode === 'monetary'
						? <CurrencyDetails currencyRate={currencyRate} />
						: <CryptoCurrencyDetails currencyRate={currencyRate} />
				}
			</div>
			<ChartTabs currency={mode === 'monetary'
				? currencyRate.to_currency_id
				: currencyRate.to_crypto_currency_id
			} mode={mode} {...props} />
		</div>
	</div>
}

export default SingleCurrency
